module.exports = __webpack_public_path__ + "static/img/协保宝.88f32e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/协保宝.png
// module id = kF5k
// module chunks = 0